// import {
//   Box,
//   Button,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   FormControl,
//   Grid,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
// import DataTable from "react-data-table-component";
// import { useTQuery } from "../../utils/useTQuery";
// import { useEffect, useState } from "react";
// import dayjs from "dayjs";
// import CloseIcon from '@mui/icons-material/Close';
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import showToast from "../Hot-Toast/showToast";
// import { calculateGrandTotalTime } from "../../utils/genericMethod";
// import { useTMutation } from "../../utils/useTMutation";
// import { useSelector } from "react-redux";

// const customStyles = {
//   rows: {
//     style: {
//       minHeight: "45px",
//       paddingLeft: "8px",
//       paddingRight: "8px",
//     },
//   },
//   headCells: {
//     style: {
//       backgroundColor: "#f5f5f5",
//     },
//   },
//   cells: {
//     style: {
//       paddingLeft: "8px",
//       paddingRight: "8px",
//     },
//   },
// };

// export const JobtTimeSheet = (props) => {
//   const allOptions = ['Work', 'Meal Time', 'Free Time'];
//   const currentDate = new Date();
//   const { selectedCard } = useSelector((state) => state.selectedJob);
//   const [timeSheetStatus, setTimeSheetStatus] = useState("")
//   const [serviceID, setServiceID] = useState("")
//   const { data, refetch, isLoading } = useTQuery(
//     ["jobs"],
//     `job/fetchJobTimeSheets?${new URLSearchParams({
//       JOB_ID: selectedCard?.ID,
//     }).toString()}`
//   );

//   const {
//     data: scheduleJobTimeSheets,
//     refetch: refetchSchedule,
//     isLoading: loadingSchedule,
//   } = useTQuery(
//     ["scheduleJobTimeSheets", selectedCard?.ID],
//     selectedCard?.ID
//       ? `/job/fetchScheduleJobTimeSheets?${new URLSearchParams({
//           JOB_ID: selectedCard?.ID,
//         }).toString()}`
//       : null,
//     "get",
//     !!selectedCard?.ID
//   );
//   const { mutateAsync: mutation } = useTMutation("/job/fetchJobTimeSheet", "post", (data => {
//     if (data?.STATUS) {
//       setTimeEntries(data?.OUTPUT[0]?.WORK_TIME);
//       console.log(data?.OUTPUT[0]?.WORK_TIME);
//       setTimeSheetStatus(data?.OUTPUT[0]?.STATUS)
//     } else {
//       setTimeEntries([]);
//       setTimeSheetStatus("");
//     }
//   }))

//   const [editIndex, setEditIndex] = useState(null);
//   const [grandTotalTime, setGrandTotalTime] = useState("0h 0m");
//   const [timeEntries, setTimeEntries] = useState(data?.timesheet?.WORK_TIME || []);
//   const [dateValue, setDateValue] = useState([]);
//   const [formData, setFormData] = useState({
//     timeEntryName: "",
//     jobServiceID: "",
//     jobIn: null,
//     jobOut: null,
//     totalTime: "",
//   });

//   const handleChange = (key, value) => {
//     setFormData((prev) => ({ ...prev, [key]: value }));
//   };

//   useEffect(() => {
//     if (timeEntries !== undefined) {
//       setGrandTotalTime(calculateGrandTotalTime(timeEntries));
//     }

//   }, [timeEntries]);

//   const addMoreTime = () => {
//     const { timeEntryName, jobIn, jobOut } = formData;
//     console.log("timeEntries", timeEntries)
//     // Validate required fields
//     if (!timeEntryName || !jobIn || !jobOut || !serviceID) {
//       alert("Please fill all the fields before adding.");
//       return;
//     }
//     // Ensure Clock In time is less than Clock Out time
//     const inTime = dayjs(jobIn);
//     const outTime = dayjs(jobOut);

//     if (inTime.isAfter(outTime)) {
//       alert("Clock In time must be earlier than Clock Out time.");
//       return;
//     }
//     // Calculate total time
//     const diff = outTime.diff(inTime, "minute");
//     const hours = Math.floor(diff / 60);
//     const minutes = diff % 60;
//     const totalTime = `${hours}h ${minutes}m`;

//     if (editIndex !== null) {
//       // Update existing entry
//       setTimeEntries((prev) =>
//         prev.map((entry, i) =>
//           i === editIndex
//             ? { Time_Entry: timeEntryName, CLOCK_IN: inTime.format("HH:mm"), CLOCK_OUT: outTime.format("HH:mm"), totalTime }
//             : entry
//         )
//       );
//       setEditIndex(null);
//     }
//     else {
//       // Add new entry
//       const isDuplicate = timeEntries.some((entry) => entry.Time_Entry === timeEntryName);
//       if (isDuplicate) {
//         showToast("error", `Time Entry Type "${timeEntryName}" already exists. Please choose another type.`);
//         return;
//       }

//       setTimeEntries((prev) => [
//         ...prev,
//         { Time_Entry: timeEntryName, CLOCK_IN: inTime.format("HH:mm"), CLOCK_OUT: outTime.format("HH:mm"), totalTime }
//         // { timeEntryName, jobIn: inTime.format("HH:mm"), jobOut: outTime.format("HH:mm"), totalTime },
//       ]);
//     }

//     setFormData({
//       timeEntryName: "",
//       jobIn: null,
//       jobOut: null,
//       totalTime: "",
//     });
//   };

//   const handleSaveTime = async () => {

//     if (timeEntries.length === 0) {
//       return showToast("error", "Add Time Entry")
//     }
//     await mutateAsync({ work: timeEntries, workType: "Job", grandTotalTime, userId: selectedCard?.cliniciansInFacilityJobShifts[0]?.clinicianId, workTypeID: selectedCard?.cliniciansInFacilityJobShifts[0]?.jobID, ID: selectedCard?.cliniciansInFacilityJobShifts[0]?.ID, jobServiceID: serviceID });
//     props.handleCancel(false)
//   };

//   const { mutateAsync } = useTMutation(
//     "/job/addUpdateTimeSheet",
//     "post",
//     (response) => {
//       showToast(response.STATUS ? 'success' : 'error', response.MESSAGE, 3000)
//       if (response.STATUS) {
//         // handleCancel();
//       }
//     }
//   );

//   useEffect(() => {
//     if (data?.OUTPUT) {
//       function sortByDate(a, b) {
//         if (a.JOB_DATE < b.JOB_DATE) {
//           return -1;
//         }
//         if (a.JOB_DATE > b.JOB_DATE) {
//           return 1;
//         }
//         return 0;
//       }
//       const sorted = data?.OUTPUT.sort(sortByDate);
//       setDateValue(sorted);
//     }
//   }, [data, refetch]);
//   const columns = [
//     {
//       name: "Entry Name",
//       valuesName: "Time_Entry",
//       selector: (row) => row.Time_Entry,
//       reorder: true,
//       sortable: true,
//     },
//     {
//       name: "Clock In",
//       valuesName: "CLOCK_IN",
//       selector: (row) => row?.CLOCK_IN,
//       reorder: true,
//       sortable: true,
//       style: { paddingLeft: "  20px" },
//     },
//     {
//       name: "Clock Out",
//       valuesName: "CLOCK_OUT",
//       selector: (row) => row?.CLOCK_OUT,
//       reorder: true,
//       sortable: true,
//       style: { paddingLeft: "26px" },
//     },
//     {
//       name: 'Actions',
//       button: true,
//       cell: (row, index) => (
//         <>
//           <div style={{ paddingLeft: "18px" }} onClick={() => { timeSheetStatus !== "Approved" && handleEditEntry(index) }} disabled={timeSheetStatus === "Approved"}>
//             <Tooltip title="Edit Job"  >

//               <IconButton size="small">
//                 <EditOutlinedIcon />
//               </IconButton>

//             </Tooltip>

//           </div>
//           <div onClick={() => { timeSheetStatus !== "Approved" && handleDeleteEntry(index) }}>
//             <Tooltip title="Delete Job" >

//               <IconButton size="small">
//                 <CloseIcon />
//               </IconButton>

//             </Tooltip>

//           </div>

//         </>

//       ),
//       reorder: true,
//       center: true
//     }
//   ];

//   const handleDeleteEntry = (index) => {
//     setTimeEntries((prev) => prev.filter((_, i) => i !== index));
//   };
//   const handleEditEntry = (index) => {
//     const entryToEdit = timeEntries[index];
//     setFormData({
//       timeEntryName: entryToEdit.Time_Entry,
//       jobIn: dayjs(entryToEdit.CLOCK_IN, "HH:mm"), // Convert back to dayjs
//       jobOut: dayjs(entryToEdit.CLOCK_OUT, "HH:mm"),
//       totalTime: entryToEdit.totalTime,
//     });
//     setEditIndex(index); // Set the editing index
//   };
//   const selectedDate = dateValue.filter(function (el) {
//     return serviceID == el.ID;
//   })

//   // Get TimeSheet
//   function checkTimeSheet(e) {
//     let s = {
//       COMMON_ID: selectedCard?.cliniciansInFacilityJobShifts[0]?.jobID,
//       USER_ID: selectedCard?.cliniciansInFacilityJobShifts[0]?.clinicianId,
//       jobServiceID: e
//     }
//     mutation(s)
//   }

//   const handleJobDateChange = (e) => {
//     const selectedJob = dateValue.find(date => date.ID === e.target.value);
//     setServiceID(e.target.value);
//     checkTimeSheet(e.target.value);
//     console.log("selectedJob", selectedJob)
//     if (selectedJob) {
//       setFormData(prev => ({
//         ...prev,
//         timeEntryName: "Work",
//         jobIn: selectedJob.JOB_IN_TIME ? dayjs(selectedJob.JOB_IN_TIME, "HH:mm") : null,
//         jobOut: selectedJob.JOB_OUT_TIME ? dayjs(selectedJob.JOB_OUT_TIME, "HH:mm") : null
//       }));
//     }
//   };

//   return (
//     <>
//       <Dialog
//         open={props.openTimeSheetPopup}
//         onClose={props.handleCancel}
//         maxWidth="md"
//         fullWidth>
//         <Box
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             backgroundColor: "linear-gradient(to right,#4eb3e8,#6ebe44)",
//             color: "#ffffff",
//           }}>
//           <DialogTitle mt={0.5} style={{ fontSize: "14px", color: "black" }}>
//             Time Sheet Details
//           </DialogTitle>
//         </Box>
//         <DialogContent>
//           <Grid container spacing={2}>
//             {/* Time Entry Type */}
//             <Grid item xs={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="demo-simple-select-label">Time Entry Type11</InputLabel>
//                 <Select
//                   label="Time Entry Type"
//                   labelId="demo-simple-select-label"
//                   value={formData.timeEntryName}
//                   disabled={timeSheetStatus === "Approved"}
//                   onChange={(e) => handleChange("timeEntryName", e.target.value)}
//                 >
//                   {allOptions.map((option) => (
//                     <MenuItem key={option} value={option}>
//                       {option}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="demo-simple-select-label">Job Dates</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   value={selectedDate[0]?.JOB_DATE}
//                   label="Job Dates"
//                   // onChange={(e) => { setServiceID(e.target.value); checkTimeSheet(e.target.value) }}>
//                   onChange={handleJobDateChange}>
//                   {dateValue?.map((date) => {
//                     return (
//                       <MenuItem
//                         key={date.ID}
//                         value={date.ID}
//                         disabled={currentDate < new Date(date.JOB_DATE)}>
//                         {new Date(date.JOB_DATE).toDateString()}
//                       </MenuItem>
//                     );
//                   })}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Clock In */}
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <Grid item xs={12} lg={6}>
//                 <MobileTimePicker
//                   label="Clock In"
//                   value={formData.jobIn}
//                   onChange={(value) => handleChange("jobIn", value)}
//                   disabled={timeSheetStatus == "Approved"}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       placeholder="Clock in"
//                       fullWidth
//                       helperText={!formData.jobIn && "Clock In time is required"}
//                     />
//                   )}
//                 />
//               </Grid>
//             </LocalizationProvider>

//             {/* Clock Out */}
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <Grid item xs={12} lg={6}>
//                 <MobileTimePicker
//                   label="Clock Out"
//                   value={formData.jobOut}
//                   onChange={(value) => handleChange("jobOut", value)}
//                   disabled={timeSheetStatus == "Approved"}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       placeholder="Clock out"
//                       fullWidth
//                       helperText={!formData.jobOut && "Clock Out time is required"}
//                     />
//                   )}
//                 />
//               </Grid>
//             </LocalizationProvider>
//             {timeSheetStatus === "Approved" &&
//               <Grid item lg={12}>
//                 <DialogTitle mt={0.5} style={{ fontSize: "14px", textAlign: "center", color: "#71ba32" }}>
//                   Time Sheet {timeSheetStatus}
//                 </DialogTitle></Grid>}

//             {/* Add More Button */}
//             {timeSheetStatus !== "Approved" &&
//               <Grid item lg={2.5}>
//                 <Button variant="contained" color="error" onClick={addMoreTime}  >
//                   Add More
//                 </Button>
//               </Grid>}
//             <Grid item lg={12}>
//               <DataTable
//                 className="table-items"
//                 columns={columns}
//                 data={timeEntries}
//                 customStyles={customStyles}
//               />
//             </Grid>
//             {/* Total Time */}
//             <Grid container justifyContent={"end"}>
//               <Grid item lg={2} mt={1}>
//                 <TextField
//                   label="Total Time"
//                   variant="outlined"
//                   fullWidth
//                   value={grandTotalTime}
//                   autoFocus
//                   sx={{
//                     "& .MuiOutlinedInput-input": { padding: 1.814 },
//                     "& .MuiFormHelperText-root": {
//                       marginLeft: 0,
//                       marginTop: "4px",
//                     },
//                   }}
//                 />
//               </Grid>
//             </Grid>

//             {/* Buttons */}
//             <Grid container mt={3} justifyContent={"center"} gap={2}>
//               <Button
//                 variant="outlined"
//                 color="secondary"
//                 sx={{ width: "90px" }}
//                 onClick={props.handleCancel}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 color="error"
//                 sx={{ width: "90px" }}
//                 disabled={timeSheetStatus == "Approved"}
//                 onClick={handleSaveTime}
//               >
//                 Save
//               </Button>
//             </Grid>
//           </Grid>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import DataTable from "react-data-table-component";
import { useTQuery } from "../../utils/useTQuery";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import showToast from "../Hot-Toast/showToast";
import { useTMutation } from "../../utils/useTMutation";
import { useSelector } from "react-redux";

const customStyles = {
  rows: {
    style: {
      minHeight: "45px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f5f5f5",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
};

export const JobtTimeSheet = (props) => {
  const allOptions = ["Work", "Meal Time", "Free Time"];
  const currentDate = new Date();
  const { selectedCard } = useSelector((state) => state.selectedJob);
  const [timeSheetStatus, setTimeSheetStatus] = useState("");
  const [serviceID, setServiceID] = useState("");
  const { data, refetch, isLoading } = useTQuery(
    ["jobs"],
    `job/fetchJobTimeSheets?${new URLSearchParams({
      JOB_ID: selectedCard?.ID,
    }).toString()}`,
  );

  const {
    data: scheduleJobTimeSheets,
    refetch: refetchSchedule,
    isLoading: loadingSchedule,
  } = useTQuery(
    ["scheduleJobTimeSheets", selectedCard?.ID],
    selectedCard?.ID
      ? `/job/fetchScheduleJobTimeSheets?${new URLSearchParams({
          JOB_ID: selectedCard?.ID,
        }).toString()}`
      : null,
    "get",
    !!selectedCard?.ID,
  );

  const { mutateAsync: fetchTimeSheetMutation } = useTMutation(
    "/job/fetchJobTimeSheet",
    "post",
    (data) => {
      if (data?.STATUS) {
        // setTimeEntries(data?.OUTPUT[0]?.WORK_TIME);
        console.log(data?.OUTPUT[0]?.WORK_TIME);
        // setTimeSheetStatus(data?.OUTPUT[0]?.STATUS);
      } else {
        // setTimeEntries([]);
        // setTimeSheetStatus("");
      }
    },
  );

  const [editIndex, setEditIndex] = useState(null);
  const [grandTotalTime, setGrandTotalTime] = useState("0h 0m");
  const [timeEntries, setTimeEntries] = useState(
    data?.timesheet?.WORK_TIME || [],
  );
  const [dateValue, setDateValue] = useState([]);
  const [formData, setFormData] = useState({
    timeEntryName: "",
    jobServiceID: "",
    jobIn: null,
    jobOut: null,
    totalTime: "",
  });

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const parseEntryMinutes = (entry) => {
    if (!entry) return 0;

    const total = entry.totalTime || entry.TOTAL_TIME || "";
    if (typeof total === "string" && total.trim()) {
      const hourMatch = total.match(/(\d+)\s*h/i);
      const minuteMatch = total.match(/(\d+)\s*m/i);
      const hours = parseInt(hourMatch?.[1] || "0", 10);
      const minutes = parseInt(minuteMatch?.[1] || "0", 10);
      return hours * 60 + minutes;
    }

    if (entry.CLOCK_IN && entry.CLOCK_OUT) {
      const inTime = dayjs(entry.CLOCK_IN, "HH:mm");
      const outTime = dayjs(entry.CLOCK_OUT, "HH:mm");
      const diff = outTime.diff(inTime, "minute");
      return diff > 0 ? diff : 0;
    }

    return 0;
  };

  useEffect(() => {
    const entries = Array.isArray(timeEntries) ? timeEntries : [];
    const totalMinutes = entries.reduce(
      (sum, entry) => sum + parseEntryMinutes(entry),
      0,
    );
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    setGrandTotalTime(`${totalHours}h ${remainingMinutes}m`);
  }, [timeEntries]);

  const addMoreTime = () => {
    const { timeEntryName, jobIn, jobOut } = formData;
    if (!timeEntryName || !jobIn || !jobOut || !serviceID) {
      alert("Please fill all the fields before adding.");
      return;
    }
    const inTime = dayjs(jobIn);
    const outTime = dayjs(jobOut);

    if (inTime.isAfter(outTime)) {
      alert("Clock In time must be earlier than Clock Out time.");
      return;
    }

    const diff = outTime.diff(inTime, "minute");
    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;
    const totalTime = `${hours}h ${minutes}m`;

    if (editIndex !== null) {
      setTimeEntries((prev) =>
        prev.map((entry, i) =>
          i === editIndex
            ? {
                Time_Entry: timeEntryName,
                CLOCK_IN: inTime.format("HH:mm"),
                CLOCK_OUT: outTime.format("HH:mm"),
                totalTime,
              }
            : entry,
        ),
      );
      setEditIndex(null);
    } else {
      const isDuplicate = timeEntries.some(
        (entry) => entry.Time_Entry === timeEntryName,
      );
      if (isDuplicate) {
        showToast(
          "error",
          `Time Entry Type "${timeEntryName}" already exists. Please choose another type.`,
        );
        return;
      }
      setTimeEntries((prev) => [
        ...prev,
        {
          Time_Entry: timeEntryName,
          CLOCK_IN: inTime.format("HH:mm"),
          CLOCK_OUT: outTime.format("HH:mm"),
          totalTime,
        },
      ]);
    }
    setFormData({
      timeEntryName: "",
      jobIn: null,
      jobOut: null,
      totalTime: "",
    });
  };

  const handleSaveTime = async () => {
    if (timeEntries.length === 0) {
      return showToast("error", "Add Time Entry");
    }
    if (!serviceID) {
      return showToast("error", "Please select a job date");
    }
    try {
       const [hoursPart, minutesPart] = grandTotalTime.split(" ");

    const hours = parseInt(hoursPart?.replace("h", ""), 10) || 0;
    const minutes = parseInt(minutesPart?.replace("m", ""), 10) || 0;

    // convert to decimal hours
    const totalHours = hours + minutes / 60;

    const hourlyRate =
      selectedCard?.cliniciansInFacilityJobShifts[0]?.clinicianPayRate || 0;

    const paymentAmount = Number((hourlyRate * totalHours).toFixed(2));

      await mutateAsync({
        work: timeEntries,
        workType: "Job",
        grandTotalTime,
        paymentAmount,
        userId: selectedCard?.cliniciansInFacilityJobShifts[0]?.clinicianId,
        workTypeID: selectedCard?.cliniciansInFacilityJobShifts[0]?.jobID,
        ID: selectedCard?.ID,
        // ID: selectedCard?.cliniciansInFacilityJobShifts[0]?.ID,
        jobServiceID: selectedCard?.job_services[0]?.ID,
      });
      // callback in useTMutation handles the rest
    } catch (error) {
      showToast("error", "Failed to save timesheet");
    }
  };

  const { mutateAsync } = useTMutation(
    "/job/addUpdateTimeSheet",
    "post",
    (response) => {
      showToast(response.STATUS ? "success" : "error", response.MESSAGE, 3000);
      if (response.STATUS) {
        refetch(); // ← refetch timesheet list
        refetchSchedule(); // ← refetch schedule
        props.handleCancel(false); // ← close popup on success
        if (props.onSuccess) props.onSuccess(); // ← trigger MyJobs refetch
      }
    },
  );

  useEffect(() => {
    if (scheduleJobTimeSheets?.OUTPUT) {
      const sorted = scheduleJobTimeSheets?.OUTPUT.map((item) => ({
        ...item,
        JOB_DATE: item.startDate, // <----- NEW FIELD MAPPED HERE
      })).sort((a, b) => new Date(a.JOB_DATE) - new Date(b.JOB_DATE));
      setDateValue(sorted);
    }
  }, [scheduleJobTimeSheets]);

  const columns = [
    {
      name: "Entry Name",
      valuesName: "Time_Entry",
      selector: (row) => row.Time_Entry,
      reorder: true,
      sortable: true,
    },
    {
      name: "Clock In",
      valuesName: "CLOCK_IN",
      selector: (row) => row?.CLOCK_IN,
      reorder: true,
      sortable: true,
      style: { paddingLeft: "20px" },
    },
    {
      name: "Clock Out",
      valuesName: "CLOCK_OUT",
      selector: (row) => row?.CLOCK_OUT,
      reorder: true,
      sortable: true,
      style: { paddingLeft: "26px" },
    },
    {
      name: "Actions",
      button: true,
      cell: (row, index) => (
        <>
          <div
            style={{ paddingLeft: "18px" }}
            onClick={() => {
              timeSheetStatus !== "Approved" && handleEditEntry(index);
            }}
            disabled={timeSheetStatus === "Approved"}
          >
            <Tooltip title="Edit Job">
              <IconButton size="small">
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div
            onClick={() => {
              timeSheetStatus !== "Approved" && handleDeleteEntry(index);
            }}
          >
            <Tooltip title="Delete Job">
              <IconButton size="small">
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
      reorder: true,
      center: true,
    },
  ];

  const handleDeleteEntry = (index) => {
    setTimeEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditEntry = (index) => {
    const entryToEdit = timeEntries[index];
    setFormData({
      timeEntryName: entryToEdit.Time_Entry,
      jobIn: dayjs(entryToEdit.CLOCK_IN, "HH:mm"),
      jobOut: dayjs(entryToEdit.CLOCK_OUT, "HH:mm"),
      totalTime: entryToEdit.totalTime,
    });
    setEditIndex(index);
  };

  const selectedDate = dateValue.filter((el) => serviceID === el.ID);

  function checkTimeSheet(e) {
    let s = {
      COMMON_ID: selectedCard?.ID,
      USER_ID: selectedCard?.cliniciansInFacilityJobShifts[0]?.clinicianId,
      jobServiceID: e,
    };
    fetchTimeSheetMutation(s);
  }

  const handleJobDateChange = (e) => {
    const selectedJob = dateValue.find((date) => date.ID === e.target.value);
    setServiceID(e.target.value);
    checkTimeSheet(e.target.value);
    if (selectedJob) {
      setFormData((prev) => ({
        ...prev,
        timeEntryName: "Work",
        jobIn: selectedJob.startTime
          ? dayjs(selectedJob.startTime, "HH:mm")
          : null,
        jobOut: selectedJob.endTime
          ? dayjs(selectedJob.endTime, "HH:mm")
          : null,
      }));
    }
  };

  return (
    <>
      <Dialog
        open={props.openTimeSheetPopup}
        onClose={props.handleCancel}
        maxWidth="md"
        fullWidth
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "linear-gradient(to right,#4eb3e8,#6ebe44)",
            color: "#ffffff",
          }}
        >
          <DialogTitle mt={0.5} style={{ fontSize: "14px", color: "black" }}>
            Time Sheet Details
          </DialogTitle>
        </Box>
        <DialogContent>
          {dateValue.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "300px",
                textAlign: "center",
                gap: 2,
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No Job Dates Available
              </Typography>
              <Typography variant="body2" color="textSecondary">
                There are no scheduled dates for this job. Please contact the facility to schedule shifts before submitting timesheet.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={props.handleCancel}
              >
                Close
              </Button>
            </Box>
          ) : (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Time Entry Type
                </InputLabel>
                <Select
                  label="Time Entry Type"
                  labelId="demo-simple-select-label"
                  value={formData.timeEntryName}
                  disabled={timeSheetStatus === "Approved"}
                  onChange={(e) =>
                    handleChange("timeEntryName", e.target.value)
                  }
                >
                  {allOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Job Dates</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={serviceID} // ← use serviceID directly (already set on change)
                  label="Job Dates"
                  onChange={handleJobDateChange}
                >
                  {dateValue?.map((date) => {
                    return (
                      <MenuItem
                        key={date.ID}
                        value={date.ID}
                        disabled={currentDate < new Date(date.startDate)} // ← use startDate
                      >
                        {new Date(date.startDate).toDateString()}{" "}
                        {/* ← use startDate */}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            {/* Clock In */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Grid item xs={12} lg={6}>
                <MobileTimePicker
                  label="Clock In"
                  value={formData.jobIn}
                  onChange={(value) => handleChange("jobIn", value)}
                  disabled={timeSheetStatus == "Approved"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Clock in"
                      fullWidth
                      helperText={
                        !formData.jobIn && "Clock In time is required"
                      }
                    />
                  )}
                />
              </Grid>
            </LocalizationProvider>

            {/* Clock Out */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Grid item xs={12} lg={6}>
                <MobileTimePicker
                  label="Clock Out"
                  value={formData.jobOut}
                  onChange={(value) => handleChange("jobOut", value)}
                  disabled={timeSheetStatus == "Approved"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Clock out"
                      fullWidth
                      helperText={
                        !formData.jobOut && "Clock Out time is required"
                      }
                    />
                  )}
                />
              </Grid>
            </LocalizationProvider>
            {timeSheetStatus === "Approved" && (
              <Grid item lg={12}>
                <DialogTitle
                  mt={0.5}
                  style={{
                    fontSize: "14px",
                    textAlign: "center",
                    color: "#71ba32",
                  }}
                >
                  Time Sheet {timeSheetStatus}
                </DialogTitle>
              </Grid>
            )}

            {timeSheetStatus !== "Approved" && (
              <Grid item lg={2.5}>
                <Button variant="contained" color="error" onClick={addMoreTime}>
                  Add More
                </Button>
              </Grid>
            )}
            <Grid item lg={12}>
              <DataTable
                className="table-items"
                columns={columns}
                data={timeEntries}
                customStyles={customStyles}
              />
            </Grid>
            <Grid container justifyContent={"end"}>
              <Grid item lg={2} mt={1}>
                <TextField
                  label="Total Time"
                  variant="outlined"
                  fullWidth
                  value={grandTotalTime}
                  autoFocus
                  sx={{
                    "& .MuiOutlinedInput-input": { padding: 1.814 },
                    "& .MuiFormHelperText-root": {
                      marginLeft: 0,
                      marginTop: "4px",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container mt={3} justifyContent={"center"} gap={2}>
              <Button
                variant="outlined"
                color="secondary"
                sx={{ width: "90px" }}
                onClick={props.handleCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={{ width: "90px" }}
                disabled={timeSheetStatus == "Approved"}
                onClick={handleSaveTime}
              >
                Save
              </Button>
            </Grid>
          </Grid>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
